import { defineQuery } from 'next-sanity'
import { imageFields, inlineCtaFields } from '../atoms'

export const gridBlockFields = `
  _id,
  _type,
  title,
  items[]{
    _type,
    ...select(
      _type == "grid-block-image" => {
        image {
          ${imageFields}
        },
        isFullWidth
      },
      _type == "grid-block-copy" => {
        title,
        body,
        isFullWidth,
        backgroundColor,
        cta {
          ${inlineCtaFields}
        }
      }
    )
  }
`

export const GRID_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "grid-block"][0]{
    ${gridBlockFields}
  }
`)
